import { render } from "./FruitColletion.vue?vue&type=template&id=a2e5335c"
import script from "./FruitColletion.vue?vue&type=script&lang=js"
export * from "./FruitColletion.vue?vue&type=script&lang=js"
script.render = render

export default script